export const REFRESH_LAST_UPDATED_INTERVAL = 1000;

export const LIST_FILTER_SHORT_MAX_LENGTH = 6;

export const dateTimeTransferFormat = 'YYYYMMDDTHHmmssZ';
export const dateTimeDisplayFormat = 'DD MMM YYYY, HH:mm';

export const dateTransferFormat = 'YYYYMMDD';
export const dateDisplayFormat = 'DD MMM YYYY';
